module.exports = __webpack_public_path__ + "static/media/cefc-main-bg.b3e23a34.png";